import { IAction } from 'core/interface/action';
import { IUser } from 'core/interface/user';

export const SAVE_USER = 'SAVE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_USER_LOADING = 'SET_USER_LOADING';

export const SaveUser = (user: IUser) => ({
  type: SAVE_USER,
  payload: user
});

export const UpdateUser = (user: IUser) => ({
  type: UPDATE_USER,
  payload: user
});

export const RemoveUser = () => ({
  type: REMOVE_USER
});

export const SetUserLoading = (loading: boolean) => ({
  type: SET_USER_LOADING,
  payload: loading
});

const initialState = {
  user: null as IUser | null,
  userLoading: true as boolean
};

type UserAction =
  | IAction<IUser>
  | { type: typeof SET_USER_LOADING; payload: boolean };

const userReducer = (state = initialState, action: UserAction) => {
  switch (action.type) {
    case SAVE_USER:
      return {
        ...state,
        user: action.payload,
        userLoading: false
      };
    case REMOVE_USER:
      return {
        ...state,
        user: null,
        userLoading: false
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload
      };
    case SET_USER_LOADING:
      return {
        ...state,
        userLoading: action.payload
      };
    default:
      return state;
  }
};

export default userReducer;
